/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".wrapperButton[_ngcontent-%COMP%]{margin:0;padding:0;border-width:0;background-color:transparent}img[_ngcontent-%COMP%]{cursor:pointer}"];
export { styles as styles };
